// this is an autogenerated file from DesignSystem/GenerateLettersModal/Content/Letters/Letter/Recipient/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_GenerateLettersModal_Content_Letters_Letter_Recipient(
  $org_id: uuid!
  $template_names: [String!]!
) {
  documents_get_document_templates_for_org(
    args: { org_id: $org_id }
    where: { name: { _in: $template_names } }
  ) {
    _id
    name
  }
}

`